import { Routes } from '@angular/router'

import {HomeComponent} from './pages/home/home.component'
import {LoginComponent} from './pages/login/login.component'
import {FinanceiroComponent} from "./pages/financeiro/financeiro.component"
import {CadOperComponent} from "./pages/cad-oper/cad-oper.component"

import { CategoriaAtendimentoComponent } from './pages/administracao/categoria-atendimento/categoria-atendimento.component'
import { CurriculoComponent } from './pages/administracao/curriculo/curriculo.component'
import { ResetSenhaComponent } from './pages/administracao/reset-senha/reset-senha.component'
import { VisualizarPdfComponent } from './pages/financeiro/visualizar-pdf/visualizar-pdf.component'
import { EditCurriculoComponent } from './pages/administracao/curriculo/edit-curriculo/edit-curriculo.component'
import { VersaoComponent } from './pages/administracao/versao/versao.component'
import { EditarCategoriaComponent } from './pages/administracao/categoria-atendimento/editar-categoria/editar-categoria.component'
import { EditVersaoComponent } from './pages/administracao/versao/edit-versao/edit-versao.component'
import {CartaQuitacaoComponent} from './pages/financeiro/carta-quitacao/carta-quitacao.component'

export const ROUTES: Routes = [
    {path:'login', component: LoginComponent},
    {path:'home', component: HomeComponent},
    {path:'financeiro', component: FinanceiroComponent},
    {path:'carta', component: CartaQuitacaoComponent},
    {path:'cad-oper', component: CadOperComponent},
    {path:'administrativo/cate-atendimento', component: CategoriaAtendimentoComponent},
    {path:'administrativo/curriculos', component: CurriculoComponent},
    {path:'administrativo/curriculos/editar', component: EditCurriculoComponent},
    {path:'administrativo/reset-senha', component: ResetSenhaComponent},
    {path:'administrativo/versao-loja', component: VersaoComponent},
    {path:'administrativo/cate-atendimento/editar', component: EditarCategoriaComponent},
    {path:'administrativo/versao/editar', component: EditVersaoComponent},
    {path:'financeiro/pdf', component: VisualizarPdfComponent},
    {path:'', component: LoginComponent},
    {path:'**', component: LoginComponent}
]



// WEBPACK FOOTER //
// ./src/app/app.routes.ts